import { useSpotsChartsDataContext } from "./hooks/useSpotsChartsDataContext";
import { SpotsMap } from "../../../Common/Charts/SpotsMap";

const SPOTS_CONFIG = {
    popupFields: {
        title: "rubrica",
        local: "desc_tipolocal",
        logradouro: "logradouro",
    },
    filters: [
        { key: "rubrica", label: "Filtrar por Rubrica", type: "select" },
    ],
    details: {
        title: "rubrica",
        localType: "desc_subtipolocal",
        period: { month: "mes_registro_bo", year: "ano_registro_bo" },
    },
    stats: [
        { label: "Total de ocorrências", type: "count" },
        { label: "Rubricas únicas", field: "rubrica", type: "unique" },
        { label: "Períodos", type: "period", monthField: "mes_registro_bo", yearField: "ano_registro_bo" },
    ],
};

export function Spots() {
    const { chartData } = useSpotsChartsDataContext();

    return <SpotsMap spots={chartData?.spots || []} config={SPOTS_CONFIG} />;
}